<script setup lang="ts">
import { CarouselPlayerIcon } from "./CarouselPlayerIcon.props"

const props = withDefaults(defineProps<CarouselPlayerIcon>(), {
  wrapperIconClasses:
    "absolute left-0 top-0 flex h-full w-full items-center justify-center",
  iconClasses: "h-[50%] w-[50%]"
})
</script>

<template>
  <div :class="wrapperIconClasses">
    <IconsVideoPlayer :class="`${iconClasses} text-${iconColor}`" />
  </div>
</template>
